module.exports = require("oauth-1.0a");